"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _preact = _interopRequireWildcard(require("preact"));

var _DoormatList = _interopRequireDefault(require("./DoormatList"));

var _DoormatAddress = _interopRequireDefault(require("./DoormatAddress"));

var _SocialLink = _interopRequireDefault(require("../header/SocialLink"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var Doormat = /*#__PURE__*/function (_Component) {
  _inherits(Doormat, _Component);

  var _super = _createSuper(Doormat);

  function Doormat() {
    var _this;

    _classCallCheck(this, Doormat);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));

    _defineProperty(_assertThisInitialized(_this), "_renderBlock", function (block, blockIdentifier) {
      return block.map(function (s, i) {
        switch (s.type) {
          case 'list':
            return (0, _preact.h)(_DoormatList["default"], {
              linksRenderFunction: _this.props.linksRenderFunction,
              title: s.title,
              items: s.items,
              blockIndex: i,
              richText: s.richText,
              blockIdentifier: blockIdentifier
            });

          case 'address':
            return (0, _preact.h)(_DoormatAddress["default"], s);

          case 'html':
            return (0, _preact.h)("div", {
              className: "mtn-m-html" // eslint-disable-next-line react/no-danger
              ,
              dangerouslySetInnerHTML: {
                __html: s.content
              }
            });

          default:
            return null;
        }
      });
    });

    return _this;
  }

  _createClass(Doormat, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
          bottomTitle = _this$props.bottomTitle,
          bottomLinks = _this$props.bottomLinks,
          topLink = _this$props.topLink,
          topLabel = _this$props.topLabel,
          topTitle = _this$props.topTitle,
          topTitleHidden = _this$props.topTitleHidden,
          left = _this$props.left,
          topTarget = _this$props.topTarget,
          right = _this$props.right,
          center = _this$props.center,
          style = _this$props.style,
          className = _this$props.className;
      return (0, _preact.h)("div", {
        id: "mtn-doormat",
        style: style,
        className: "mtn-o-doormat ".concat(className ? className : '')
      }, topLink && (0, _preact.h)("aside", {
        id: "mtn-doormat-top",
        className: "u-wrapper"
      }, (0, _preact.h)("div", {
        className: "u-container"
      }, (0, _preact.h)("div", {
        className: "mtn-o-doormat__top"
      }, (0, _preact.h)("h2", {
        className: "u-screen-reader-only"
      }, topTitleHidden || topTitle), (0, _preact.h)("div", {
        id: "mtn-footer-top-title",
        className: "mtn-o-doormat__top-title"
      }, (0, _preact.h)("span", {
        className: "fa fa-bell-o"
      }), (0, _preact.h)("span", {
        className: "mtn-o-doormat__top-text"
      }, topTitle, ' ', (0, _preact.h)("a", {
        className: "mtn-o-doormat__top-link",
        href: topLink,
        target: topTarget,
        id: "mtn-footer-top-link"
      }, topLabel)))))), left.length || right.length || center.length ? (0, _preact.h)("nav", {
        id: "mtn-doormat-middle",
        className: "mtn-o-doormat__navigation"
      }, (0, _preact.h)("div", {
        className: "u-wrapper"
      }, (0, _preact.h)("div", {
        className: "u-container"
      }, (0, _preact.h)("div", {
        className: "mtn-o-doormat__box row",
        id: "mtn-doormat-middle-grid"
      }, (0, _preact.h)("div", {
        id: "mtn-doormat-middle-left",
        className: "col-xs-12 col-md-4 col-lg-4"
      }, this._renderBlock(left, 'left')), (0, _preact.h)("div", {
        id: "mtn-doormat-middle-center",
        className: "col-xs-12 col-md-4 col-lg-4"
      }, this._renderBlock(center, 'center')), (0, _preact.h)("div", {
        id: "mtn-doormat-middle-right",
        className: "col-xs-12 col-md-4 col-lg-4"
      }, this._renderBlock(right, 'right')))))) : null, bottomTitle || bottomLinks.length ? (0, _preact.h)("div", {
        id: "mtn-doormat-bottom",
        className: "mtn-o-doormat__bottom u-mtn-bg-white"
      }, (0, _preact.h)("div", {
        className: "mtn-o-doormat__box u-wrapper"
      }, (0, _preact.h)("div", {
        className: "u-container"
      }, (0, _preact.h)("nav", {
        className: "mtn-m-dmsocial"
      }, (0, _preact.h)("h3", {
        id: "mtn-doormat-bottom-social-title",
        className: "mtn-ts-h5 mtn-m-dmsocial__title"
      }, bottomTitle), (0, _preact.h)("div", {
        id: "mtn-doormat-bottom-social",
        className: "mtn-m-dmsocial__links"
      }, bottomLinks.map(function (x) {
        return (0, _preact.h)(_SocialLink["default"], {
          id: "mtn-doormat-bottom-social-".concat(x.type),
          url: x.url,
          name: x.type,
          withLabel: true,
          label: x.label
        });
      })))))) : null);
    }
  }]);

  return Doormat;
}(_preact.Component);

Doormat.defaultProps = {
  left: [],
  right: [],
  center: [],
  linksRenderFunction: null,
  style: {},
  topLink: '',
  topLabel: '',
  topTarget: '_blank',
  topTitle: '',
  topTitleHidden: '',
  bottomTitle: '',
  bottomLinks: [],
  className: ''
};
var _default = Doormat;
exports["default"] = _default;